import { useMemo } from "react";
import { BookingService } from "@/services/BookingService";
import { useQuery } from "@tanstack/react-query";

interface UseBookingQueryOptions {
  enabled?: boolean;
  staleTime?: number;
}

export function useBookingQuery(bookingId: string, options: UseBookingQueryOptions = {}) {
  const {
    enabled = true,
    staleTime = 5 * 60 * 1000, // 5 minutes
  } = options;

  const bookingService = useMemo(() => new BookingService(), []);

  return useQuery({
    queryKey: ["booking", bookingId],
    queryFn: () => bookingService.getBookingById(bookingId),
    enabled: enabled && !!bookingId,
    staleTime,
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff up to 30 seconds
  });
}
